var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper",staticClass:"hint-preview"},[_c('div',{staticClass:"hint-preview__widget-element"},[_vm._v(" Button ")])])}
var staticRenderFns = []

export { render, staticRenderFns }